import { buildAppointmentWhatsAppUrl, type WhatsAppBookingDetails } from '../../utils/whatsapp';

interface Props {
  booking: WhatsAppBookingDetails | null;
}

/**
 * Último paso de la reserva: el cliente envía el detalle de la cita por
 * WhatsApp al admin. Abre wa.me con el mensaje ya redactado.
 */
export default function WhatsAppConfirmStep({ booking }: Props) {
  if (!booking) return null;
  const url = buildAppointmentWhatsAppUrl(booking);

  return (
    <div className="mt-8 bg-[#25D366]/10 border border-[#25D366]/30 rounded-2xl p-6 text-center">
      <div className="w-12 h-12 rounded-full bg-[#25D366] flex items-center justify-center mx-auto mb-4">
        <i className="ri-whatsapp-line text-white text-2xl" />
      </div>
      <h4 className="font-serif text-brand-black text-lg font-medium">
        Último paso: confírmanos por WhatsApp
      </h4>
      <p className="font-sans text-brand-gray-500 text-sm leading-relaxed mt-2 max-w-sm mx-auto">
        Envíanos el detalle de tu cita por WhatsApp para agilizar la confirmación. El mensaje ya está redactado, solo pulsa enviar.
      </p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-5 inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-sans text-sm tracking-wide font-medium px-8 py-3.5 rounded-full hover:bg-[#1eb954] transition-colors whitespace-nowrap"
      >
        <i className="ri-whatsapp-line text-lg" />
        Enviar confirmación por WhatsApp
      </a>
    </div>
  );
}
